import AdvtPage from './AdvtPage';

const DashboardPage = (props: any) => {
  const dashboardData = props.data;

  const cardView = (data = { count: 0, type: "", label: "" }) => {
    let icon = "question";
    switch (data.type) {
      case "total_questions":
        icon = "question";
        break;
      case "subjects":
        icon = "book";
        break;
      case "mcqs":
        icon = "check";
        break;
      case "questions_pending":
        icon = "hourglass-half";
        break;
      case "doubts":
        icon = "question";
        break;
      case "questions_completed":
        icon = "star";
        break;
      case "revision_questions":
        icon = "history";
        break;
      case "tests":
        icon = "file-alt";
        break;
      case "total_fastrack_questions":
        icon = "question";
        break;
      default:
        break;
    }
    return (
      <div className="col-lg-4 col-md-4 col-4 col-xs-6">
        <div className="mini-stat clearfix bg-dbcard rounded">
          <span className="mini-stat-icon"><i className={`fa fa-${icon} fg-dbcard`}></i></span>
          <div className="mini-stat-info">
            <span>{data.count}</span>
            {data.label}
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
    <div className="d-flex flex-column flex-shrink-0 p-3 text-white col-lg-6 col-md-6 bg-blue position-relative">
      <div className={"row"}>
        {cardView({ type: "total_questions", label: "Total Questions", count: dashboardData.total_questions })}
        {cardView({ type: "subjects", label: "Total Subjects", count: dashboardData.subjects })}
        {cardView({ type: "total_fastrack_questions", label: "Fast Track Qs", count: dashboardData.total_fastrack_questions })}
        {cardView({ type: "doubts", label: "Questions in Doubt", count: dashboardData.doubts })}
        {cardView({ type: "questions_completed", label: "Questions Done", count: dashboardData.questions_completed })}
        {cardView({ type: "questions_pending", label: "Questions Undone / Pending", count: dashboardData.questions_pending })}
        {cardView({ type: "revision_questions", label: "Questions in LDR", count: dashboardData.revision_questions })}
        {cardView({ type: "tests", label: "Questions in Test", count: dashboardData.tests })}
      </div>
      {/* <div className={"row"}>
        <div className='col-lg-4 col-md-4'>
          <div className="advt-bottom">
            <div className="advt-bottom-1">
              <a href={advtData[0]?.target_url} target='_blank'><img src={advtData[0]?.file_link} className='image-responsive'/></a>
            </div>
            <div className="advt-bottom-1">
              <a href={advtData[1]?.target_url} target='_blank'><img src={advtData[1]?.file_link} className='image-responsive'/></a>
            </div>
          </div>
        </div>
      </div> */}
    </div>
    <div className='col-lg-6 col-md-6 p-3'>
      <AdvtPage />
    </div>
    
    </>
  );
}

export default DashboardPage;
